module.exports = "/wp-content/plugins/farmacy/assets/js/images/heart_outlined-d144008a2c220adc6ec20c56bbd5c09c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/favourite-button/img/heart_outlined.png
 ** module id = 138
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 137
 **/